<template>
  <div></div>
</template>

<script>
export default {
  name: 'EditProfile',
  data: () => ({}),
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/organisms/settings/profiles/modal-edit-profile.vue